export const emojiKey = 'EJ/lg*SS(8w#8^+';
